import { cn } from '@/common/utils/utils'
import { FC } from 'react'

type FreeTradeItem = {
    className?: string
    icon?: React.ReactNode
    title: string
    description: string
}

export const OrderRewardItem: FC<FreeTradeItem> = ({ icon, title, description, className }) => {
    return (
        <div
            className={cn(
                'w-full self-stretch p-4 rounded-2xl outline outline-1 outline-offset-[-1px] outline-neutral-300 inline-flex justify-start items-center gap-2.5 overflow-hidden',
                className,
            )}
        >
            <div className="flex-1 flex justify-start items-start gap-4 text-brand-grass">
                {icon}
                <div className="flex-1 inline-flex flex-col justify-center items-start gap-2">
                    <div className="self-stretch justify-center text-brand-grass text-sm font-medium font-['Inter'] leading-5">
                        {title}
                    </div>
                    <div className="self-stretch justify-start text-brand-grass text-sm font-normal font-['Inter'] leading-5">
                        {description}
                    </div>
                </div>
            </div>
        </div>
    )
}
